import type { IStockRepository } from '@/features/stock/domain/repositories/IStockRepository.js';

interface Deps { stockRepository: IStockRepository; }

export interface RecalcProjectParams { orgId: string; projectId: string; }

export function createRecalcProjectUseCase({ stockRepository }: Deps) {
  return async function recalcProject({ orgId, projectId }: RecalcProjectParams): Promise<void> {
    return stockRepository.recalcProject(orgId, projectId);
  };
}
